import $ from 'jquery';
import config from './../../../../config';

export function save_letter( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'SAVE_LETTER',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "SAVE_LETTER",
				letter: response
			})
		})

	}
}

export function get_users( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'requests/letter/',
            data: {
				method: 'GET_USER_LET',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_USER_LET",
				letter: response
			});
		});

	}
}


export function get_letter( user, let_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'GET_LETTER',
				user: user,
				let_id: let_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_LETTER",
				letter: response
			})
		})

	}
}


export function delete_letter( letter_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'DELETE_LETTER',
				letter_id: letter_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "DELETE_LETTER",
				letter: response
			})
		})

	}
}

export function block_letter( letter_id, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'BLOCK_LETTER',
                letter_id: letter_id,
                block: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "BLOCK_LETTER",
				letter: response
			})
		})

	}
}


export function update_RequestingFor( letter_id, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'UPDATE_REQUEST_FOR',
                letter_id: letter_id,
                requesting_for: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_REQUEST_FOR",
				letter: response
			})
		})

	}
}

export function update_address( letter_id, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'UPDATE_ADDRESS',
                letter_id: letter_id,
                address: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_ADDRESS",
				letter: response
			})
		})

	}
}

export function update_purpose( letter_id, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'UPDATE_PURPOSE',
                letter_id: letter_id,
                purpose: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_PURPOSE",
				letter: response
			})
		})

	}
}


export function update_remarks( letter_id, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'UPDATE_REMARKS',
                letter_id: letter_id,
                remarks: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_REMARKS",
				letter: response
			})
		})

	}
}


export function update_date( letter_id, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/letter/',
			data: {
                method: 'UPDATE_DATE',
                letter_id: letter_id,
                date: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "UPDATE_DATE",
				letter: response
			})
		})

	}
}





// WEBPACK FOOTER //
// ./src/pages/requests/letter/actions/letter.action.js